import { takeLatest, put, call } from 'redux-saga/effects';
import swal from 'sweetalert';

import { history } from '@commons';

import { deletePatrimonioCadastro } from '../service';
import {
  DELETE_PATRIMONIO_CADASTRO,
  DELETE_PATRIMONIO_CADASTRO_PENDING,
  DELETE_PATRIMONIO_CADASTRO_SUCCESS,
  DELETE_PATRIMONIO_CADASTRO_FAILURE,
} from '../actionTypes';

import { AlertError } from '@components/common/AlertToast'
import { trackingEventCX, MODULE_ACTIONS_ENUM } from '@handler/tracking/customerX';

function* sagaDeletePatrimonioCadastro(action) {
  yield put({ type: DELETE_PATRIMONIO_CADASTRO_PENDING, id: action.id })

  trackingEventCX('action', MODULE_ACTIONS_ENUM.CADASTRO_PATRIMONIO_EXCLUIR);

  try {
    const a = yield call(deletePatrimonioCadastro, action.id);

    if (a.status !== 204) {
      throw new Error('API delete request failed');
    }
    yield put({ type: DELETE_PATRIMONIO_CADASTRO_SUCCESS, id: action.id });

    swal({
      title: 'Excluído!',
      icon: 'success',
      buttons: {
        cancel: false,
        confirm: {
          text: 'OK',
          value: true,
          visible: true,
          className: 'btn-primary',
          closeModal: true
        }
      }
    }).then(() => {
      history.go(0)
    });

  } catch (error) {

    yield put({ type: DELETE_PATRIMONIO_CADASTRO_FAILURE });

    AlertError('Falha ao excluir o registro! Tente novamente...');
  }
}

export default function* watchDeletePatrimonioCadastro() {
  yield takeLatest(DELETE_PATRIMONIO_CADASTRO, sagaDeletePatrimonioCadastro)
}
